import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

export type DataPoint = {
  year: number;
  totalSales: number;
};

type Props = {
  data: DataPoint[];
};

const formatCurrency = (value: number) => {
  const valueInMillions = value / 1000000000;
  return `$${valueInMillions.toLocaleString('es-CL')}`;
};

const CustomTooltip = ({ active, payload, label, coordinate }: any) => {
  if (active && payload && payload.length) {
    const filteredPayload = payload.filter((entry: any) => entry.value > 0);
    if (filteredPayload.length === 0) {
      return null;
    }
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: '#fff',
          padding: '10px',
          border: '1px solid #ccc',
          position: 'absolute',
          top: coordinate.y,
          left: coordinate.x,
          transform: 'translate(10%, 0%)',
          zIndex: 1000,
          fontSize: '0.875rem',
          fontFamily: 'Roboto, Helvetica, Arial',
          fill: 'rgba(0, 0, 0, 0.6)',
        }}
      >
        <p className="label">{`Año: ${label}`}</p>
        {filteredPayload.map((entry: any, index: any) => (
          <p key={`item-${index}`} style={{ color: entry.color }}>
            {`${entry.name}: ${formatCurrency(entry.value)}`}
          </p>
        ))}
      </div>
    );
  }

  return null;
};

function LineChartComponent({ data }: Props) {
  return (
    <div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 50, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="year"
            tick={{
              fontSize: '0.875rem',
              fontFamily: 'Roboto, Helvetica, Arial',
              fill: 'rgba(0, 0, 0, 0.6)',
            }}
          />
          <YAxis
            tickFormatter={(value: number) => formatCurrency(value)}
            tick={{
              fontSize: '0.875rem',
              fontFamily: 'Roboto, Helvetica, Arial',
              fill: 'rgba(0, 0, 0, 0.6)',
            }}
            label={{
              value: 'Total ventas (miles de millones)',
              angle: -90,
              position: 'insideLeft',
              offset: -30,
              style: {
                textAnchor: 'middle',
                fontSize: '0.875rem',
                fontFamily: 'Roboto, Helvetica, Arial',
                fill: 'rgba(0, 0, 0, 0.6)',
              },
            }}
          />
          <Tooltip content={CustomTooltip} />
          <Legend
            wrapperStyle={{
              fontSize: '0.875rem',
              fontFamily: 'Roboto, Helvetica, Arial',
              color: 'rgba(0, 0, 0, 0.6)',
            }}
          />
          <Line
            type="linear"
            dataKey="totalSales"
            name="Total Ventas"
            stroke="#8884d8"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default LineChartComponent;
